"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var Tooltip = function Tooltip(props) {
  var children = props.children,
    text = props.text;
  var _useState = (0, _react.useState)(false),
    isActive = _useState[0],
    setActive = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    tooltipDisplayed = _useState2[0],
    setTooltipDisplayed = _useState2[1];
  var closeTooltip = function closeTooltip() {
    setTooltipDisplayed(true);
    setActive(false);
  };
  (0, _react.useEffect)(function () {
    var close = isActive && !tooltipDisplayed && setTimeout(function () {
      closeTooltip();
    }, 3000);
    return function () {
      clearInterval(close);
    };
  }, [isActive]);
  return tooltipDisplayed ? __jsx(_Box["default"], null, children) : __jsx(_Box["default"], {
    sx: {
      position: "relative",
      zIndex: 1,
      cursor: tooltipDisplayed ? "auto" : "pointer"
    },
    onClick: function onClick() {
      return setActive(true);
    }
  }, isActive && __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      zIndex: 2,
      font: "xs",
      color: "white",
      borderRadius: 5,
      p: "s5",
      backgroundColor: "active",
      top: "110%",
      minWidth: ["100px", null, null, "200px"],
      left: ["-90px", null, null, "-168px"]
    },
    onClick: function onClick() {
      return closeTooltip();
    }
  }, __jsx(_Box["default"], {
    as: "span",
    sx: {
      position: "absolute",
      bottom: "100%",
      right: "10%",
      ml: "-5px",
      borderWidth: "5px",
      borderStyle: "solid",
      borderLeftColor: "transparent",
      borderRightColor: "transparent",
      borderBottomColor: "active",
      borderTopColor: "transparent"
    }
  }), text), __jsx(_Box["default"], {
    sx: {
      position: "relative",
      zIndex: 100
    }
  }, children));
};
var _default = Tooltip;
exports["default"] = _default;